import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getCompanyStatus() {
  const response = await axiosClient.get("/delivery-company/status");
  return response.data;
}

export async function getDashboard(period) {
  const response = await axiosClient.get(`/delivery-company/dashboard${toQueryString({ period })}`);
  return response.data;
}

export async function getDrivers(params) {
  const response = await axiosClient.get(`/delivery-company/drivers${toQueryString(params)}`);
  return response.data;
}

export async function getDriverStats(driverId, params) {
  const response = await axiosClient.get(`/delivery-company/drivers/${driverId}/stats${toQueryString(params)}`);
  return response.data;
}

export async function getDriverStoreStats(driverId, params) {
  const response = await axiosClient.get(`/delivery-company/drivers/${driverId}/store-stats${toQueryString(params)}`);
  return response.data;
}

export async function getDriverStoreOrders(driverId, storeId, params) {
  const response = await axiosClient.get(
    `/delivery-company/drivers/${driverId}/store-stats/${storeId}/orders${toQueryString(params)}`
  );
  return response.data;
}

export async function getDistricts() {
  const response = await axiosClient.get("/delivery-company/districts");
  return response.data;
}

export async function getDriverAccess(driverId) {
  const response = await axiosClient.get(`/delivery-company/drivers/${driverId}/access`);
  return response.data;
}

export async function updateDriverAccess(driverId, hasFullAccess, pairs, districts) {
  const response = await axiosClient.put(`/delivery-company/drivers/${driverId}/access`, {
    hasFullAccess,
    pairs,
    districts,
  });
  return response.data;
}

export async function getDeliveries(params) {
  const response = await axiosClient.get(`/delivery-company/deliveries${toQueryString(params)}`);
  return response.data;
}

export async function getDeliveryDetail(deliveryId) {
  const response = await axiosClient.get(`/delivery-company/deliveries/${deliveryId}`);
  return response.data;
}

export async function getDriverActiveDeliveries(driverId, status) {
  const response = await axiosClient.get(
    `/delivery-company/deliveries${toQueryString({ driverId, status, excludeDelivered: true, pageSize: 200 })}`
  );
  return response.data;
}

export async function reassignDeliveries(deliveryIds, toDriverUserId, reason) {
  const response = await axiosClient.put(`/delivery-company/deliveries/reassign`, {
    deliveryIds,
    toDriverUserId,
    reason,
  });
  return response.data;
}

export async function getTransferHistory(params) {
  const response = await axiosClient.get(`/delivery-company/driver-transfers${toQueryString(params)}`);
  return response.data;
}

export async function getEarnings(period) {
  const response = await axiosClient.get(`/delivery-company/earnings${toQueryString({ period })}`);
  return response.data;
}

export async function getDriverEarningsByMonth(month) {
  const response = await axiosClient.get(`/delivery-company/driver-earnings${toQueryString({ month })}`);
  return response.data;
}

export async function getStoreEarnings(period) {
  const response = await axiosClient.get(`/delivery-company/stores${toQueryString({ period })}`);
  return response.data;
}

export async function getCommission() {
  const response = await axiosClient.get("/delivery-company/commission");
  return response.data;
}

export async function getFeeRequests(params) {
  const response = await axiosClient.get(`/delivery-company/fee-requests${toQueryString(params)}`);
  return response.data;
}

export async function confirmFeeSent(settlementId) {
  const response = await axiosClient.post(`/delivery-company/fee-requests/${settlementId}/confirm-sent`);
  return response.data;
}

export async function confirmFeeSentBulk(settlementIds) {
  const response = await axiosClient.post(`/delivery-company/fee-requests/confirm-sent-bulk`, { settlementIds });
  return response.data;
}

export async function getStorePayouts() {
  const response = await axiosClient.get("/delivery-company/store-fees");
  return response.data;
}

export async function getStorePayoutHistory() {
  const response = await axiosClient.get("/delivery-company/store-fees/history");
  return response.data;
}

export async function sendStorePayout(storeId, note) {
  const response = await axiosClient.post(`/delivery-company/store-fees/${storeId}/send`, { note });
  return response.data;
}
